import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ReviewList from './ReviewList';
import { ReviewSummary } from './ReviewSummary';
import CreateReview from '../../containers/CreateReview';
import SingleReview from './SingleReview';
import UserControls from './UserControls';

import Button from 'widgets/Button';
import Rating from 'widgets/Rating/Rating';
import { scrollToYourReview } from '../../utils/createReview';
import { requestLogin } from 'utils/loginAndRegistration/login';

export class Reviews extends PureComponent {
  static propTypes = {
    reviews: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    fetchReviews: PropTypes.func.isRequired,
    deleteReview: PropTypes.func.isRequired,
    setActivePage: PropTypes.func.isRequired,
    resetActivePage: PropTypes.func.isRequired,
    setHelpfulness: PropTypes.func.isRequired,
    setModalVisibility: PropTypes.func.isRequired,
    updateFields: PropTypes.func.isRequired,
    sku: PropTypes.string.isRequired,
    summary: PropTypes.object.isRequired,
    activePage: PropTypes.number,
    sortOrder: PropTypes.string,
    setSortOrder: PropTypes.func.isRequired,
    modalVisible: PropTypes.bool,
    router: PropTypes.object,
    isLoggedIn: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sku !== this.props.sku) {
      this.props.resetActivePage();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.scrollTimeout);
  }

  scrollTimeout = null;

  closeAddReviewModal = () => {
    const { setModalVisibility } = this.props;
    setModalVisibility(false);
    this.scrollTimeout = setTimeout(scrollToYourReview, 100);
  };

  renderCustomerReview = () => {
    const {
      totalCount,
      deleteReview,
      setHelpfulness,
      sku,
      summary = {},
      updateFields,
      setModalVisibility,
      router,
      isLoggedIn,
    } = this.props;

    const { customerReview } = summary;
    const customerReviewId = customerReview && customerReview.reviewId;
    const showHeader = customerReviewId || !(totalCount === 0);

    return <>
      {showHeader && <h4 className="bop-reviews__subheader">Your rating and review</h4>}
      {customerReview
        ? (
          <SingleReview
            review={customerReview}
            sku={sku}
            Controls={UserControls}
            deleteReview={deleteReview}
            setHelpfulness={setHelpfulness}
            customerReviewId={customerReviewId}
            isLoggedIn={isLoggedIn}
            router={router}
          />
        )
        : ((
          <>
            <div
              className={classNames(
                'bop-reviews__newReview',
                { 'bop-reviews__newReview--noReviews': !totalCount }
              )}
            >
              <div className="bop-reviews__fastReview">
                <Rating
                  active
                  large
                  reviewStats={{ averageRate: 0 }}
                  withoutTitle
                  onChange={rating => {
                    updateFields({ rating });
                    if (isLoggedIn) {
                      setModalVisibility(true);
                    } else {
                      requestLogin(router);
                    }
                  }}
                />
                <Button
                  className="bop-reviews__addReview"
                  onClick={() => {
                    if (isLoggedIn) {
                      setModalVisibility(true);
                    } else {
                      requestLogin(router);
                    }
                  }}
                >
                  Leave a review
                </Button>
              </div>
            </div>
          </>)
        )
      }
    </>;
  };

  renderReviewsList = () => {
    const {
      reviews,
      totalCount,
      fetchReviews,
      setHelpfulness,
      setActivePage,
      resetActivePage,
      sku,
      activePage,
      sortOrder,
      summary,
      setSortOrder,
      isLoggedIn,
      router,
    } = this.props;

    const { customerReview } = summary;
    const customerReviewId = customerReview && customerReview.reviewId;

    const showHeader = customerReviewId || !(totalCount === 0);

    return (
      <div id="customerReviews" className="bop-reviews__list">
        {showHeader && (
        <h4 className="bop-reviews__subheader">
          Customer reviews {totalCount > 0 && `(${totalCount})` }
        </h4>
        )}
        <ReviewList
          isLoggedIn={isLoggedIn}
          reviews={reviews}
          totalCount={totalCount}
          fetchReviews={fetchReviews}
          sortOrder={sortOrder}
          sku={sku}
          setHelpfulness={setHelpfulness}
          setActivePage={setActivePage}
          resetActivePage={resetActivePage}
          customerReviewId={customerReviewId}
          activePage={activePage}
          setSortOrder={setSortOrder}
          router={router}
        />
      </div>
    );
  };

  render() {
    const {
      sku,
      summary,
    } = this.props;

    const { modalVisible } = this.props;
    const shouldShowSummary = summary && summary.numberOfReviews > 0;

    return (
      <>
        <h3 className="bop-reviews__header">Ratings and reviews</h3>
        {shouldShowSummary && <ReviewSummary summary={summary} />}
        <div className="bop-reviews__wrapper">
          { this.renderReviewsList()}
          <div id="yourReview" className="bop-reviews__yourReview">
            {modalVisible && (
              <CreateReview
                sku={sku}
                onClose={this.closeAddReviewModal}
              />
            )}
            {this.renderCustomerReview()}
          </div>
        </div>
      </>
    );
  }
}
